import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Typography } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const Ul = styled('ul')(
    ({ theme }: ParamsStyle) => `
        padding-left: 1.5rem;
        margin-bottom: 1.4375rem;

        li {
            text-align: start;
            padding-bottom: .2rem;
            list-style-type: disc;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const BoxSvg = styled('div')(
    ({ theme }: ParamsStyle) => `
        position: relative;
        right: 0;

        svg {
            margin-left: 1.6875rem;
            transition: all 0.4s ease;
        }

        &.show {
            svg {
                transform: rotate(180deg);
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            position: absolute;
            right: 3.75rem;

            svg {
                margin-left: 0;
            }
        }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: 1rem;
    width: 225px;
    position: relative;
    font-weight: 700;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    margin-top: .375rem;
    padding-left: .875rem;
    justify-content: flex-start;
    color: ${theme?.palette.primary.main};
    border: 2px solid ${theme?.palette.primary.main};
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);

export const TextDetails = styled(Typography)(
    ({ theme }: ParamsStyle) => `
    font-size: 1.125rem;
    padding: 0 .93rem;
    display: flex;
    width: 100%;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 5.125rem;
    font-weight: 700;
    border: 2px solid ${theme?.palette.primary.light};
    border-radius: 10px;
    z-index: 1;
    background-color: white;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: fit-content;
    }
`);